<template>
  <q-card style="width: 100vw; height: 100vh">
    <q-toolbar
      class="bg-primary text-secondary fixed"
      :class="{ 'safe-area-header': needInset.all }"
      style="z-index: 9999"
    >
      <q-btn
        class="absolute-left"
        flat
        icon="close"
        @click="$emit('closeModal')"
      />
      <q-toolbar-title class="text-center q-pl-md">
        <span class="sw-title-secondary">{{ $t('failedRequest.title') }} </span>
      </q-toolbar-title>
    </q-toolbar>
    <div class="q-pt-xl">
      <div class="q-pa-md">
        <div>
          {{ $t('common.sendInfoToDev') }}
        </div>
        <div class="q-mt-md">
          {{ $t('common.sendInfoToTeam') }}
        </div>
        <q-input class="q-mt-md" outlined v-model="message" textarea />
        <q-btn
          icon="send"
          class="sendBtn"
          @click="sendFailedRequests"
          color="primary"
          >{{ $t('issueDetails.send') }}</q-btn
        >
      </div>
    </div>
  </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SendFailedRequests',
  emits: ['closeModal'],
  data() {
    return {
      message: ''
    }
  },
  computed: {
    ...mapGetters({
      needInset: 'common/needInset'
    })
  },
  methods: {
    async sendFailedRequests() {
      try {
        await this.$store.dispatch('reporter/sendFailedRequests', this.message)
        this.$q.notify({
          message: this.$t('issueDetails.sendByEmail.sendSuccess'),
          icon: 'check',
          type: 'positive',
          position: 'top'
        })
        this.$emit('closeModal')
      } catch (err) {
        console.error('sendFailedRequests', err)
      }
    }
  }
}
</script>
<style lang="stylus">
.sendBtn {
  position: absolute;
  bottom: 64px;
  width: 90%
}
</style>
